import React from 'react';
import Icon from '../../../components/AppIcon';

const OrizonFooter = () => {
  return (
    <footer className="w-full border-t border-border/40 bg-card/30 backdrop-blur-md mt-auto">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-8 lg:px-12 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          
          {/* Ljeva strana: Brend i Status */}
          <div className="flex items-center gap-6">
            <div className="relative">
              <div className="p-3 bg-muted/30 rounded-xl">
                <Icon name="Shield" size={20} className="text-primary/60" />
              </div>
              <div className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-green-500 rounded-full border-2 border-background animate-pulse" />
            </div>
            <div className="flex flex-col">
              <div className="flex items-center gap-2">
                <span className="text-[11px] font-black tracking-widest uppercase text-foreground">OrizonDesk</span>
                <span className="text-[8px] font-bold px-1.5 py-0.5 bg-primary/10 text-primary rounded tracking-tighter">ENTERPRISE</span>
              </div>
              <span className="text-[10px] font-bold text-muted-foreground uppercase tracking-widest mt-0.5 text-center md:text-left">
                Cloud Database Sincronizzato
              </span>
            </div>
          </div>
          
          {/* Desna strana: Verzija i Stability */}
          <div className="flex items-center gap-8">
             <div className="flex flex-col items-end">
                <span className="text-[9px] font-bold text-muted-foreground/40 uppercase tracking-[0.2em]">Build Core</span>
                <span className="text-[11px] font-black tracking-tight">v3.2.0-2026</span>
             </div>
             <div className="h-8 w-[1px] bg-border/40 hidden sm:block" />
             <div className="flex items-center gap-2 text-primary/40">
                <Icon name="Zap" size={16} />
                <span className="text-[10px] font-black uppercase tracking-widest">Stable</span>
             </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default OrizonFooter;